import type { RolesResponse, UserRoleCatalogDTO } from '@krafta/shared-types';

import type { AuthHeaders } from '@shared/api/httpClient';
import { buildUsersUrl, usersHttp } from '@shared/api/usersClient';

export async function fetchUserRoleCatalogAPI(headers: AuthHeaders): Promise<UserRoleCatalogDTO> {
  const response = await usersHttp.get<RolesResponse>(buildUsersUrl('/users/roles'), { headers });

  if (response.data.catalog) {
    return response.data.catalog;
  }

  return {
    code: 'user.roles',
    version: 'legacy-users.roles',
    items: (response.data.roles ?? []).map((role, index) => ({
      value: role,
      label: role,
      sortOrder: index,
      active: true
    }))
  };
}
